import { Box } from "@mantine/core";
import { MapBase } from "shared/components/map/MapBase";
import { MapBoundaryOverlay } from "shared/components/map/MapBoundaryOverlay";
import { MapGeoFilterOverlay } from "shared/components/map/MapGeoFilterOverlay";
import { MapPolygonDrawOverlay } from "shared/components/map/MapPolygonDrawOverlay";
import { useComposeFormContext } from "shared/components/message/compose/context";
import { GeoAudienceSenderBoundaryOverlay } from "shared/components/message/compose/geoAudience/GeoAudienceSenderBoundaryOverlay";
import { useGeoAudienceEditor } from "shared/components/message/compose/geoAudience/useGeoAudienceEditor";
import { useFormSubscription } from "shared/hooks/useFormSubscription";
import { useIsMobile } from "shared/hooks/useIsMobile";

export const GeoAudienceMapCanvas = (props: { mapId: string }) => {
    const form = useComposeFormContext();
    const features = useFormSubscription(form, "audience.features");
    const geofilters = useFormSubscription(form, "audience.geofilters");
    const { tab } = useGeoAudienceEditor();
    const isMobile = useIsMobile();

    return (
        <Box pos="relative" h={isMobile ? "50dvh" : "65dvh"} w="100%" style={{ overflow: "clip" }}>
            <MapBase id={props.mapId} interactiveLayerIds={[MapGeoFilterOverlay.layerId]}>
                <MapBoundaryOverlay hideCustomerBoundary />
                {tab === "Draw" && (
                    <>
                        <MapPolygonDrawOverlay
                            position="top-left"
                            features={features}
                            onChange={(nextFeatures) => form.setFieldValue("audience.features", nextFeatures)}
                        />
                        <MapGeoFilterOverlay widget geofilterIds={geofilters} />
                    </>
                )}
                <GeoAudienceSenderBoundaryOverlay />
            </MapBase>
        </Box>
    );
};
